import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { TailSpin } from "react-loader-spinner";

import { bGId } from "common/constants/constants";
import PhoneFieldWrapper from "common/formUI/phoneField";
import TextField from "common/formUI/textfield";
import UploadFileField from "common/formUI/uploadfileField";
import RichTextbox from "common/formUI/richTextbox";
import BranchDataSavedModal from "components/common/branchDataSavedModal/BranchDataSavedModal";
import BranchModalWrapper from "components/common/branchModalWrapper/BranchModalWrapper";
import { CommonButton } from "components/common/button/Button";
import { Form, Formik, Field } from "formik";
import * as Yup from "yup";
import { toast, Toaster } from "react-hot-toast";
import { getBranchData, updateBranchData } from "services/branchServices";
import Loader from "components/common/loader/Loader";
import "./branchDetails.scss";
import { useLocation } from "react-router-dom";
import { customStyle, inputLabelStyles } from "common/constants/constants";
import { useTranslation } from "react-i18next";
import { downloadDocument } from "services/branchServices";

const UploadBranchDocument = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { imageUrl, translatedValue, pathIds } = location.state;
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [isfetching, setIsfetching] = useState(false);
  const [initialValues, setInitialValues] = useState({
    email: "",
    phoneNumber: "",
    imprintFile: null,
    imprintUrl: "",
    emailSignature: "",
    logo: null,
    termOfUse: null,
    privacyPolicy: null,
  });
  const FILE_SIZE = 30 * 1024 * 1024;
  const SUPPORTED_FORMATS_IMAGE = ["image/jpg", "image/jpeg", "image/png"];
  const SUPPORTED_FORMATS_FILE = ["application/pdf"];

  const validate = Yup.object().shape(
    {
      phoneNumber: Yup.string()
        .matches(
          /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
          "Invalid Telefonnummer"
        )
        .required(t("required")),
      email: Yup.string()
        .email("Invalid Email Address")
        .required(t("required")),
      imprintFile: Yup.mixed().when("imprintUrl", {
        is: (val) => {
          return !val;
        },
        then: Yup.mixed()
          .required(t("required"))
          .test("fileSize", t("invalid-file-size"), (value) => {
            let isFileFormat = "File" in window && value instanceof File;
            return isFileFormat ? value && value.size <= FILE_SIZE : true;
          })
          .test("fileFormat", t("unsupported-format"), (value) => {
            let isFileFormat = "File" in window && value instanceof File;
            return isFileFormat
              ? value && SUPPORTED_FORMATS_FILE.includes(value.type)
              : true;
          }),
        otherwise: Yup.mixed().notRequired(),
      }),

      imprintUrl: Yup.string().when("imprintFile", {
        is: (val) => {
          return !val;
        },
        then: Yup.string()
          .required(t("required"))
          .url("Invalid Imprint") // Validate as URL
          .transform((v) => (v === null ? "" : v)),
        otherwise: Yup.string()
          .notRequired()
          .url("Invalid Imprint") // Validate as URL
          .transform((v) => (v === null ? "" : v)),
      }),
      emailSignature: Yup.string().test(
        "required",
        t("required"),
        (value) => value !== "<p><br></p>"
      ),
      logo: Yup.mixed()
        .required(t("required"))
        .test("fileFormat", t("unsupported-format"), (value) => {
          let isImgFormat = value && value["type"]?.split("/")[0] === "image";
          return isImgFormat
            ? value && SUPPORTED_FORMATS_IMAGE.includes(value.type)
            : true;
        })
        .test("fileSize", t("invalid-file-size"), (value) => {
          let isImgFormat = value && value["type"]?.split("/")[0] === "image";
          return isImgFormat ? value && value.size <= FILE_SIZE : true;
        }),
      termOfUse: Yup.mixed()
        .required(t("required"))
        .test("fileSize", t("invalid-file-size"), (value) => {
          let isFileFormat = "File" in window && value instanceof File;
          return isFileFormat ? value && value.size <= FILE_SIZE : true;
        })
        .test("fileFormat", t("unsupported-format"), (value) => {
          let isFileFormat = "File" in window && value instanceof File;
          return isFileFormat
            ? value && SUPPORTED_FORMATS_FILE.includes(value.type)
            : true;
        }),

      privacyPolicy: Yup.mixed()
        .required(t("required"))
        .test("fileSize", t("invalid-file-size"), (value) => {
          let isFileFormat = "File" in window && value instanceof File;
          return isFileFormat ? value && value.size <= FILE_SIZE : true;
        })
        .test("fileFormat", t("unsupported-format"), (value) => {
          let isFileFormat = "File" in window && value instanceof File;
          return isFileFormat
            ? value && SUPPORTED_FORMATS_FILE.includes(value.type)
            : true;
        }),
    },
    ["imprintFile", "imprintUrl"]
  );
  useEffect(() => {
    fetchBranchData();
  }, []);
  const fetchBranchData = async () => {
    setIsfetching(true);
    const result = await getBranchData(pathIds);

    if (result.payLoad) {
      let object = {};
      let entries = Object.entries(result.payLoad);
      entries.forEach(([key, val] = entry) => {
        object[key] = val === "null" ? "" : val;
      });
      setInitialValues(object);
    }
    setIsfetching(false);
  };
  const postBranchData = async (values) => {
    setIsLoading(true);
    const {
      imprintFile,
      logo,
      termOfUse,
      privacyPolicy,
      emailSignature,
      email,
      phoneNumber,
      imprintUrl,
      ...rest
    } = values;
    let formData = new FormData();

    imprintFile
      ? formData.append("imprintFile", imprintFile)
      : formData.append("imprintFile", {});
    formData.append("logo", logo);
    formData.append("termOfUse", termOfUse);
    formData.append("privacyPolicy", privacyPolicy);
    formData.append("emailSignature", emailSignature);
    formData.append("email", email);
    formData.append("phoneNumber", phoneNumber);
    formData.append("imprintUrl", imprintUrl);
    const result = await updateBranchData(pathIds, rest, formData);

    if (result.success) {
      setShow(true);
      fetchBranchData();
    } else {
      toast.error(t(result?.data?.message));
    }
    setIsLoading(false);
  };
  const handleSubmit = (values, { setFieldError }) => {
    postBranchData(values);
  };

  const handleClose = () => {
    setShow(false);
  };
  return (
    <div className="payment-info-container">
      <p className="page-title">{t("upload-documents")}</p>
      <hr />
      <Toaster />
      {!isfetching ? (
        <Formik
          initialValues={initialValues}
          validationSchema={validate}
          onSubmit={(values, { setFieldError }) =>
            handleSubmit(values, { setFieldError })
          }
          enableReinitialize={true}
        >
          {(formik) => {
            return (
              <Form onSubmit={formik.handleSubmit}>
                <Row className="branch-details upload-file">
                  <Col xs={12}>
                    <div className="d-flex my-3">
                      <img
                        src={`/assets/icons${imageUrl}`}
                        width={50}
                        height={50}
                      />
                      <p style={{ fontWeight: "600" }} className="my-3 px-2">
                        {translatedValue}
                      </p>
                    </div>
                  </Col>
                  <Col lg={7} xs={12}>
                    <div>
                      <p
                        style={{ fontWeight: "600", fontSize: "0.85rem" }}
                        className="my-3"
                      >
                        {t("support-contact")}
                      </p>
                      <div className="d-flex flex-lg-nowrap justify-content-between flex-wrap w-100">
                        <TextField
                          id="email"
                          label="E-Mail address"
                          name="email"
                          varient="filled"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          sx={{
                            ...customStyle,
                            width: "46.375%",
                            // marginRight: "28px",
                          }}
                          InputLabelProps={{
                            sx: inputLabelStyles,
                          }}
                        />
                        <div className="phone-field-container">
                          <PhoneFieldWrapper
                            formik={formik}
                            name="phoneNumber"
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <p
                        style={{ fontWeight: "600", fontSize: "0.85rem" }}
                        className="my-3"
                      >
                        {t("imprint")}
                      </p>
                      <div className="d-flex flex-lg-nowrap justify-content-between flex-wrap w-100">
                        <div className="imprint-file-container">
                          <UploadFileField
                            fullWidth={true}
                            formik={formik}
                            name="imprintFile"
                            extension="application/pdf"
                          />
                        </div>

                        <div className=" pt-3 d-flex">or</div>
                        <TextField
                          id="imprintUrl"
                          label="https://website.de"
                          name="imprintUrl"
                          varient="filled"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          sx={{
                            ...customStyle,
                            width: "46.375%",
                          }}
                          InputLabelProps={{
                            sx: inputLabelStyles,
                          }}
                        />
                      </div>
                    </div>
                    <div>
                      <div className="d-flex my-3">
                        <p style={{ fontWeight: "600", fontSize: "0.85rem" }}>
                          {t("email-signature")}
                        </p>
                      </div>
                      <RichTextbox
                        id="emailSignature"
                        label={t("document-signature-placeholder")}
                        name="emailSignature"
                        formik={formik}
                      />
                    </div>
                  </Col>
                  <div style={{ width: "4%" }}></div>
                  <Col lg={4} xs={12}>
                    <div>
                      <p
                        style={{ fontWeight: "600", fontSize: "0.85rem" }}
                        className="my-3"
                      >
                        {t("logo")}
                      </p>
                      <div className="upload-feild-container">
                        <UploadFileField
                          fullWidth={true}
                          formik={formik}
                          name="logo"
                          extension="image/jpeg,image/png"
                        />
                      </div>
                    </div>
                    <div>
                      <p
                        style={{ fontWeight: "600", fontSize: "0.85rem" }}
                        className="my-3"
                      >
                        {t("privacy-policy")}
                      </p>
                      <div className="upload-feild-container">
                        <UploadFileField
                          fullWidth={true}
                          formik={formik}
                          name="privacyPolicy"
                          extension="application/pdf"
                          removeFile={() => {
                            if (initialValues?.privacyPolicy?.url) {
                              const currentDate = new Date();
                              const year = currentDate.getUTCFullYear();
                              const month = (currentDate.getUTCMonth() + 1)
                                .toString()
                                .padStart(2, "0"); // Month is zero-based
                              const day = currentDate
                                .getUTCDate()
                                .toString()
                                .padStart(2, "0");
                              downloadDocument(
                                initialValues?.privacyPolicy?.url,
                                `${t(
                                  "privacy-policy-file-name"
                                )}_${initialValues?.privacyPolicy?.uploadedAt?.slice(
                                  0,
                                  10
                                )}_to_${year}-${month}-${day}`
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div>
                      <p
                        style={{ fontWeight: "600", fontSize: "0.85rem" }}
                        className="my-3"
                      >
                        {t("terms-of-use")}
                      </p>
                      <div className="upload-feild-container">
                        <UploadFileField
                          fullWidth={true}
                          formik={formik}
                          name="termOfUse"
                          extension="application/pdf"
                          removeFile={() => {
                            if (initialValues?.termOfUse?.url) {
                              const currentDate = new Date();
                              const year = currentDate.getUTCFullYear();
                              const month = (currentDate.getUTCMonth() + 1)
                                .toString()
                                .padStart(2, "0"); // Month is zero-based
                              const day = currentDate
                                .getUTCDate()
                                .toString()
                                .padStart(2, "0");
                              downloadDocument(
                                initialValues?.termOfUse?.url,
                                `${t(
                                  "term-of-use-file-name"
                                )}_${initialValues?.termOfUse?.uploadedAt?.slice(
                                  0,
                                  10
                                )}_to_${year}-${month}-${day}`
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="save-button-container d-flex justify-content-between align-items-end">
                      <p>{t("fields-are-mandatory")}</p>

                      <CommonButton
                        title={
                          isLoading ? (
                            <TailSpin
                              height="20"
                              width="20"
                              color="#ffff"
                              radius="1"
                              visible={true}
                            />
                          ) : (
                            t("save")
                          )
                        }
                        disabled={isLoading ? true : false}
                        border="none"
                        borderRadius="5px"
                        type="submit"
                      />
                    </div>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>
      ) : (
        <Loader />
      )}

      <BranchModalWrapper show={show}>
        <BranchDataSavedModal handleClose={handleClose} />
      </BranchModalWrapper>
    </div>
  );
};

export default UploadBranchDocument;
